import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { PushNotificationsSettings } from './settings-push-notifications';

export function provideSettingsElementPushNotifications(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'push-notifications',
        name: 'Push Notifications',
        icon: 'pi pi-bell',
        component: PushNotificationsSettings,
        order: 2,
        translateName: 'SETTINGS.PUSH_NOTIFICATIONS.TITLE',
        resource_key: 'pushNotifications',
        required_action: 'read',
        category: {
          id: 'integrations',
          name: 'Integrations',
          order: 2,
          translateName: 'SETTINGS.CATEGORIES.INTEGRATIONS',
        },
      },
      multi: true,
    },
  ]);
}
